<template>
	<div :ref="'accordion-' + serviceIndex + '-' + folder.name" class="accordion">
		<div class="accordion-header">
			<h5>{{getObjectTypeTitle(folder.name)}}</h5>
			<div style="margin-right: auto;" class="ml-3">
				<button type="button" class="btn btn-secondary btn-compact" @click="renderAsList=false">
					<i class="fa-solid fa-table"></i>
				</button>
				<button type="button" class="btn btn-secondary btn-compact" @click="renderAsList=true">
					<i class="fa-solid fa-list"></i>
				</button>
			</div>
			<div>
				<button class="btn btn-secondary btn-compact" @click="applyToFolder('LOCAL')">Keep LOCAL</button>
				<button class="btn btn-secondary btn-compact" @click="applyToFolder('REMOTE')">Apply REMOTE</button>
				<button class="btn btn-secondary btn-compact" @click="applyToFolder('MERGE_LOCAL')">Merge into LOCAL</button>
				<button class="btn btn-secondary btn-compact" @click="applyToFolder('MERGE_REMOTE')">Merge into REMOTE</button>

				<b-button v-b-toggle="'accordion-' + serviceIndex + '-' + folder.name" @click="scrollIntoView('accordion-' + serviceIndex + '-' + folder.name)" variant="compact">
					<i class="when-open fas fa-chevron-up"></i>
					<i class="when-closed fas fa-chevron-down"></i>
				</b-button>
			</div>
		</div>
		<b-collapse visible :id="'accordion-' + serviceIndex + '-' + folder.name" :accordion="'accordion-' + serviceIndex + '-' + folder.name" role="tabpanel" class="accordion-body">
				<div class="row" v-if="renderAsList">
					<div v-for="index in [1,2]" :key="index" class="col-12 col-xl-6 col-border" :class="`col-header-${index}`">
						<div class="row mb-2 diff-file">
							<div class="col btn-group-container"></div>
							<div class="col text-muted">Folder</div>
							<div class="col pl-0 text-muted">File</div>
						</div>
					</div>
					<div v-for="(file, fileIndex) in filteredFiles" :key="folderIndex + '-' + fileIndex" class="col-12 col-xl-6 col-border">
						<GitDiffFile
							:file="file"
							:serviceIndex="serviceIndex"
							:folderIndex="folderIndex"
							:fileIndex="fileIndex"
							@selectOption="selectOption"
							@showDiffDialog="showDiffDialog"
							:renderAsList="renderAsList"
						></GitDiffFile>
					</div>
				</div>
				<table v-else class="table">
					<thead>
						<tr>
							<th scope="col"></th>
							<th scope="col">Folder</th>
							<th scope="col">File</th>
							<th scope="col"></th>
						</tr>
					</thead>
					<tbody>
						<GitDiffFile
							v-for="(file, fileIndex) in filteredFiles" :key="file.filePath + '-' + folderIndex + '-' + fileIndex"
							:file="file"
							:serviceIndex="serviceIndex"
							:folderIndex="folderIndex"
							:fileIndex="fileIndex"
							@selectOption="selectOption"
							@showDiffDialog="showDiffDialog"
							:renderAsList="renderAsList"
						></GitDiffFile>
					</tbody>
				</table>
		</b-collapse>
	</div>
</template>

<script>
import GitDiffFile from './GitDiffFile';
import { META_FILE_EXTENSION, FILE_EXTENSION } from '../../util/gitDiffConstants';

function matchName(name, search) {
	if (!name) return false;
	if (search[0] === '/' && search[search.length-1] === '/') {
		try {
			return name.match(new RegExp(search.slice(1, search.length-1), 'i')) != null;
		} catch(e) {
			return false;
		}
	} else {
		return name.toLowerCase().indexOf(search.toLowerCase()) > -1;
	}
}

export default {
	name: "GitDiffFolder",
	props: [
		'folder',
		'serviceIndex',
		'serviceId',
		'folderIndex',
		'hideMetadataChanges',
		'search'
	],
	components: {
		GitDiffFile
	},
	data() {
		return {
			renderAsList: false
		}
	},
	computed: {
		filteredFiles() {
			let result;
			if (this.search != null && this.search != '') {
				const search = this.search;
				result = this.folder.files.filter((file) => {
					return matchName(file.name, search) || matchName(file.folderPath, search);
				});
			} else {
				result = this.folder.files;
			}
			if (this.hideMetadataChanges) {
				result = result.filter((file) => file.name.substr(-META_FILE_EXTENSION.length) !== META_FILE_EXTENSION);
			}
			return result;
		}
	},
	methods: {
		scrollIntoView(refId) {
			if (
				this.$refs[refId] && 
				this.$refs[refId].scrollIntoView
			) {
				const element = this.$refs[refId];
				const rect = element.getBoundingClientRect();
				const position = rect.top + window.scrollY;
				if (position < 0) {
					element.scrollIntoView();
				}
			}
		},
		getObjectTypeTitle(name) {
			return name.replace(/([a-z0-9])([A-Z])/g, '$1 $2').toUpperCase();
		},
		findMetaFile(file) {
			if (!file.name) return null;
			const metaFileName = file.name.slice(0, -FILE_EXTENSION.length) + META_FILE_EXTENSION;
			return this.folder.files.find((f) => f.name === metaFileName && f.folderPath === file.folderPath);
		},
		selectOption(file, selectedOption) {
			this.$emit('selectOption', file, selectedOption);
			if (this.hideMetadataChanges && file.name) {
				const metaFile = this.findMetaFile(file);
				if (metaFile) {
					this.$emit('selectOption', metaFile, selectedOption);
				}
			}
		},
		showDiffDialog(file) {
			this.$emit('showDiffDialog', this.serviceId, this.folderIndex, file);
		},
		applyToFolder(selectedOption) {
			const files = this.filteredFiles;
			if (this.hideMetadataChanges) {
				const metaFiles = files.map(this.findMetaFile).filter((f) => f != null);
				files.push(...metaFiles);
			}
			this.$emit('selectOptionFiles', files, selectedOption);
		}
	}
}
</script>
<style scoped>
	.col-header-2 {
		display: none;
	}

	@media (min-width: 1200px) {
		.col-border:nth-child(2n+1) {
			border-right: 1px solid #dee2e6;
		}
		.col-header-2 {
			display: block;
		}
	}
	header.header-sticky-top {
		position: -webkit-sticky;
		position: sticky;
		top: 0;
		z-index: 1000;
		background-color: #fafafa;
	}

	.header-sticky-top .btn,
	.btn-group-container .btn {
		display: inline-block;
	}

	.header-sticky-top .btn {
		margin-left: 1em;
	}

	.card-body table:only-child {
		margin: 0;
	}

</style>